/** Count whitespace-separated words. Used for the "min 2 words" justification
 *  comment rule on order amendments (QA #8 / WMS-9). */
export function wordCount(s) {
    return s.trim().split(/\s+/).filter(Boolean).length;
}
/**
 * Stringify a value of unknown type for display — a CSV cell, an email
 * placeholder, a sort key. `String(value)` alone turns a plain object into the
 * useless `[object Object]`, which then silently ships to a customer's invoice
 * CSV or email; anything without a meaningful `toString` is JSON-encoded
 * instead so the content survives.
 */
export function toDisplayString(value) {
    if (value === null || value === undefined)
        return '';
    if (typeof value === 'string')
        return value;
    if (typeof value === 'number' || typeof value === 'boolean' || typeof value === 'bigint') {
        return String(value);
    }
    if (typeof value === 'symbol')
        return value.description ?? value.toString();
    // A function has no meaningful display form, and printing its source into a
    // CSV or an email would be worse than printing nothing.
    if (typeof value === 'function')
        return '';
    // Date, and anything else carrying its own meaningful toString, keeps it.
    // Arrays don't count: `String([{a:1}])` is "[object Object]" again, and even
    // for primitives it drops the brackets a reader needs to see.
    const proto = Object.getPrototypeOf(value);
    if (!Array.isArray(value) && proto !== Object.prototype && proto !== null) {
        return value.toString();
    }
    try {
        return JSON.stringify(value) ?? '';
    }
    catch {
        return ''; // circular / non-serialisable — better empty than "[object Object]"
    }
}
//# sourceMappingURL=text.js.map